import { createStore } from '../../../util/mobx/generic-store/store-creator'
import { GenericStoreAsyncMethod } from '../../../util/mobx/generic-store/decorator/async-method.decorator'
import { GenericStore } from '../../../util/mobx/generic-store/generic.store'
import { CertificationResponse, CreateCertificationDto } from '../model/certification'
import { getCertifications, createCertification, deleteCertification, getEducationAndCompetencies } from '../api/certifications'
import { notificationStoreInstance } from '../../notification/store/notification.store'
import { localizationStoreInstance } from '../../localization/store/localization.store'

export class CertificationStore extends GenericStore {
  certifications?: CertificationResponse[]
  educationAndCompetencies?: string[]

  constructor() {
    super('CertificationStore')
    super.observe(this)
    super.persist({ encrypt: false })
  }

  reset() {
    this.certifications = undefined
    this.educationAndCompetencies = undefined
  }

  get hasCertifications() {
    return this.certifications && this.certifications.length > 0
  }

  get certificationsCount() {
    return this.certifications?.length || 0
  }

  @GenericStoreAsyncMethod()
  async handleGetCertifications(userId?: string) {
    const response = await getCertifications(userId)
    this.certifications = response.certifications
  }

  @GenericStoreAsyncMethod()
  async handleCreateCertification(data: CreateCertificationDto) {
    const response = await createCertification(data)
    
    if (!this.certifications) {
      this.certifications = []
    }
    this.certifications.push(response)
    
    notificationStoreInstance.enqueueSuccess(localizationStoreInstance.translation.pages.profile.certificationModal.notifications.addedSuccess())
    
    return response
  }

  @GenericStoreAsyncMethod()
  async handleDeleteCertification(certificationId: string) {
    await deleteCertification(certificationId)
    
    if (this.certifications) {
      this.certifications = this.certifications.filter(cert => cert.id !== certificationId)
    }
    
    notificationStoreInstance.enqueueSuccess(localizationStoreInstance.translation.pages.profile.certificationModal.notifications.deletedSuccess())
  }

  @GenericStoreAsyncMethod()
  async handleGetEducationAndCompetencies() {
    this.educationAndCompetencies = await getEducationAndCompetencies()
  }
}

export const {
  storeInstance: certificationStoreInstance,
  useStore: useCertificationStore,
  StoreProvider: CertificationStoreProvider,
} = createStore(new CertificationStore())